<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <p class="text-h4 text-center text-blue-darken-3">AQUALYS App</p>

        <p class="text-body-1 text-center">
          This is the AQUALYS management system application. Simple but elegant !
        </p>

        <v-divider class="my-4"></v-divider>

                <p class="text-h6 text-left text-blue-darken-3">Menu utilisateur</p>
        <p class="text-body-1 text-left">
          Le menu utilisateur, accessible depuis l'icône de profil en haut de l'application,
          propose les actions suivantes :
        </p>
        <ul class="text-body-1 text-left ml-6">
          <li><strong>Changer de thème</strong> : bascule entre le thème clair et le thème sombre.</li>
          <li><strong>Changer le mot de passe</strong> : ouvre le formulaire permettant de modifier le mot de passe du compte connecté.</li>
          <li><strong>Meta Données</strong> : accède à la page de gestion des métadonnées de l'application.</li>
          <li><strong>Déconnexion</strong> : ferme la session en cours et redirige vers la page de connexion.</li>
        </ul>

        <v-divider class="my-4"></v-divider>

        <p class="text-h6 text-left text-blue-darken-3">Sièges</p>
        <p class="text-body-1 text-left">
          La liste des « Sièges » affiche tous les sièges dans un
          tableau consultable et sélectionnable. Vous pouvez y ajouter un nouveau siège, en modifier
          un existant en cliquant sur sa ligne, supprimer un ou plusieurs sièges sélectionnés,
          rechercher des sièges par nom, signataire, téléphone ou email, et exporter le tableau.
        </p>
        <p class="text-body-1 text-left">
          Le formulaire de siège permet de créer ou modifier les
          informations d'un siège : nom, signataire, fonction du signataire, téléphone et email.
          Une fois le siège enregistré, des laveries peuvent être créées et rattachées à celui-ci
          depuis la même page.
        </p>

        <v-divider class="my-4"></v-divider>

        <p class="text-h6 text-left text-blue-darken-3">Laveries</p>
        <p class="text-body-1 text-left">
          La liste des « Laveries » affiche toutes les laveries dans un tableau consultable et
          sélectionnable. Des interrupteurs permettent de filtrer les laveries par statut
          (Signé, En cours, Perdu, Résilié). Vous pouvez y ajouter une nouvelle laverie, en
          modifier une existante en cliquant sur sa ligne, supprimer une ou plusieurs laveries
          sélectionnées, rechercher des laveries et exporter le tableau.
        </p>
        <p class="text-body-1 text-left">
          La fiche d'une laverie s'organise en panneaux dépliables : les informations du compte
          siège rattaché, les informations de la laverie elle-même, ainsi que ses avenants. Depuis
          cette fiche, il est possible de télécharger, imprimer ou sauvegarder le contrat, et
          d'ajouter un nouvel avenant à la laverie.
        </p>

        <p class="text-subtitle-1 text-left text-blue-darken-3 mt-4">
          Nouvelle laverie : du contrat à l'installation des produits
        </p>
        <p class="text-body-1 text-left">
          Voici le déroulement complet pour une nouvelle laverie, et les activités créées à chaque
          étape :
        </p>
        <ol class="text-body-1 text-left ml-6">
          <li>
            <strong>Contrat</strong> : la laverie est créée avec son contrat, au statut « En
            cours ». Le panneau « Nombre de Produits » indique les quantités prévues de chaque
            équipement (lave-linge, sèche-linge, centrales…). Aucun produit n'est encore affecté.
          </li>
          <li>
            <strong>Signature</strong> : le statut du contrat passe à « Signé » et la laverie est
            enregistrée. Le panneau « Produits » de la laverie indique alors, pour chaque
            équipement, les produits prévus, affectés et manquants, et la liste des laveries
            affiche un badge « N à affecter ».
          </li>
          <li>
            <strong>Affectation des produits</strong> (utilisateurs laverie) : depuis le panneau
            « Produits », le bouton « Ajouter » d'un équipement propose les produits en stock de ses
            types, sans dépasser la quantité prévue. Les produits choisis sont affectés à la laverie
            et passent « En préparation ». <strong>L'activité de préparation de la laverie est
            créée automatiquement</strong> avec ces produits, au statut « À faire » ; les produits
            ajoutés ensuite la rejoignent tant qu'elle n'a pas commencé. Un produit choisi par
            erreur peut être retiré tant qu'il est en préparation.
          </li>
          <li>
            <strong>Préparation</strong> : l'activité de préparation est planifiée, et chaque
            produit est contrôlé depuis le formulaire de l'activité : « Approuver » ou « À
            reprendre ». Le produit approuvé, qui doit avoir un numéro Aqua unique, passe « Prêt à
            être installé ». L'activité passe « Approuvé » lorsque tous ses produits le sont.
          </li>
          <li>
            <strong>Installation</strong> : <strong>l'activité d'installation de la laverie est
            créée automatiquement</strong> dès le premier produit approuvé, au statut « À faire » ;
            les produits approuvés ensuite la rejoignent. Elle ne peut pas être créée à la main.
            Elle est ajoutée à une tournée et assignée à un technicien.
          </li>
          <li>
            <strong>Validation</strong> : lorsque le technicien passe l'activité d'installation à
            « Faite », ses produits passent « Installé », en exploitation, et quittent le stock de
            Villebon. Le badge « N à affecter » disparaît lorsque toutes les quantités prévues sont
            affectées.
          </li>
        </ol>
        <p class="text-body-1 text-left">
          Un avenant qui ajoute des machines suit le même chemin à partir de l'étape 3 : le panneau
          « Produits » indique les produits manquants selon les nouvelles quantités. Les dates de
          chaque étape (affectation, préparation approuvée, installation…) sont enregistrées
          automatiquement dans l'historique de chaque produit.
        </p>

        <p class="text-subtitle-1 text-left text-blue-darken-3 mt-4">Produits d'une laverie</p>
        <p class="text-body-1 text-left">
          Le contrat d'une laverie prévoit le nombre de produits de chaque équipement (panneau
          « Nombre de Produits »). Les produits y sont affectés une fois le contrat signé, sans
          dépasser ces nombres. Le dernier avenant, lorsqu'il y en a, remplace les nombres du
          contrat : un nouvel avenant reprend les nombres actuels, à modifier selon ce qu'il
          change. Les équipements et les types de produits qui les remplissent sont :
        </p>
        <ul class="text-body-1 text-left ml-6">
          <li>Lave-linge : les lave-linge et les lave-linge chauffants du contrat, remplis par des lave-linge ;</li>
          <li>Sèche-linge, stacked lave-linge, stacked sèche-linge, stacked : chacun par les produits de son type ;</li>
          <li>Centrale de paiement : par un terminal de paiement, Nayax, Wi-Wash, Wimini ou Air Wallet ;</li>
          <li>Condensateur, armoire à lessive, pompe à lessive, lint trap, monnayeur, ballon d'eau chaude : chacun par les produits de son type.</li>
        </ul>
        <p class="text-body-1 text-left">
          Les autres types de produits (bidon de lessive, Anton) ne sont pas prévus par les contrats
          et ne peuvent pas être affectés à une laverie.
        </p>
        <p class="text-body-1 text-left">
          Le panneau « Produits » de la fiche laverie indique, pour chaque équipement prévu, le
          nombre de produits prévus, affectés et manquants. Les produits affectés sont ceux en
          préparation, prêts à être installés ou installés ; un produit en attente d'enlèvement ne
          compte plus, ce qui permet de lui affecter un remplaçant. Le bouton
          <strong>Ajouter</strong> d'un équipement propose les produits en stock de ses types : les
          produits choisis sont affectés à la laverie et ajoutés à son activité de préparation, créée
          si besoin. Dans la liste des laveries, la colonne « Produits » signale par un badge
          « N à affecter » les laveries au contrat signé auxquelles il manque des produits.
        </p>
        <p class="text-body-1 text-left">
          Un produit affecté par erreur peut être <strong>retiré de la préparation</strong> tant
          qu'il est « En préparation » ou « En préparation à reprendre » : bouton de retrait du
          produit dans le panneau « Produits » de la laverie, ou bouton « Retirer » du formulaire
          de l'activité de préparation. Après confirmation, il revient « En stock », n'est plus
          affecté à la laverie, et la date « Annulation » est enregistrée dans son historique ; sa
          place au contrat se libère. Une activité de préparation dont on retire le dernier produit
          est supprimée. Un produit installé ne peut pas être retiré ainsi : il quitte la laverie
          par une activité d'enlèvement.
        </p>
        <p class="text-body-1 text-left">
          Un produit n'est jamais retiré directement depuis la fiche d'une laverie : ce sont les
          activités qui l'en détachent (voir « Cycle de vie des produits »). Le bouton de retrait
          d'un produit de la fiche laverie est donc désactivé.
        </p>
        <p class="text-body-1 text-left">
          Un produit est rattaché à une laverie, toujours dans la limite de son contrat signé :
        </p>
        <ul class="text-body-1 text-left ml-6">
          <li>
            lorsqu'il est ajouté depuis le panneau « Produits » de la laverie, ou à une
            <strong>activité de préparation</strong> de cette laverie. Seul un produit « En stock »
            (ou dont la préparation est à reprendre) peut l'être. Le produit passe « En préparation »
            et la date d'affectation est enregistrée dans son historique ;
          </li>
          <li>
            ou lorsqu'il est choisi comme <strong>produit de remplacement</strong> d'un produit
            installé dans cette laverie (bouton « Remplacer » de la fiche produit) : il est ajouté
            à l'activité de préparation de la laverie.
          </li>
        </ul>
        <p class="text-body-1 text-left">
          Un nouveau produit ne peut pas être créé directement dans une laverie : il entre
          toujours en stock dans un dépôt.
        </p>
        <p class="text-body-1 text-left">
          Rattaché à la laverie, le produit reste dans son dépôt tant qu'il n'est pas installé :
          pendant la préparation et en attendant l'installation, il apparaît à la fois dans la
          laverie et dans le dépôt de Villebon. Il quitte le dépôt lorsque son activité
          d'installation passe à « Faite » : il devient alors « Installé » et en exploitation.
        </p>
        <p class="text-body-1 text-left">Un produit est détaché de sa laverie :</p>
        <ul class="text-body-1 text-left ml-6">
          <li>
            lorsque son <strong>activité d'enlèvement</strong> passe à « Faite » : il revient en
            stock au dépôt de Villebon, comme produit d'occasion ;
          </li>
          <li>
            lorsqu'il est <strong>retiré de sa préparation</strong>, tant qu'il est en préparation
            : il revient « En stock » ;
          </li>
          <li>
            lorsque son activité de préparation ou d'installation est <strong>supprimée</strong>
            avant l'installation : il revient « En stock » ;
          </li>
          <li>
            lorsque sa préparation, à reprendre, est refaite dans une activité de préparation
            d'<strong>une autre laverie</strong> : il est alors rattaché à cette autre laverie ;
          </li>
        </ul>
        <p class="text-body-1 text-left">
          Une laverie qui a encore des produits rattachés ne peut pas être supprimée, ni le siège
          auquel elle appartient : ses produits doivent d'abord la quitter par une activité
          d'enlèvement, ou par la suppression de leur activité de préparation ou d'installation.
          Une laverie sans produit est supprimée avec ses activités.
        </p>

        <v-divider class="my-4"></v-divider>

        <p class="text-h6 text-left text-blue-darken-3">Produits</p>
        <p class="text-body-1 text-left">
          La page « Produits » propose deux vues, sélectionnables via les boutons en haut de page :
          un <strong>Tableau</strong> et une <strong>Recherche</strong>.
        </p>
        <p class="text-body-1 text-left">
          La vue Tableau affiche tous les produits dans un tableau consultable et sélectionnable,
          avec des interrupteurs pour filtrer par statut (Disponible, Réservé, Détruit). Vous
          pouvez y ajouter un nouveau produit, en modifier un existant en cliquant sur sa ligne,
          supprimer un ou plusieurs produits sélectionnés, rechercher des produits et exporter le
          tableau.
        </p>
        <p class="text-body-1 text-left">
          La vue Recherche permet de filtrer les produits selon plusieurs critères combinés :
          fabricant, type de produit, modèle, statut du produit, statut de réservation et plage de
          dates de destruction. Depuis cette même page, chaque produit trouvé peut être édité
          individuellement.
        </p>
        <p class="text-body-1 text-left">
          Les modèles de produits sont gérés depuis la page « Modèles des produits », accessible
          depuis les métadonnées. Elle permet de filtrer les modèles par marque ou par nom, de
          créer un nouveau modèle, et de modifier un modèle existant.
        </p>
        <p class="text-body-1 text-left">
          La fiche d'un produit affiche les éléments suivants :
        </p>
        <ul class="text-body-1 text-left ml-6">
          <li>
            <strong>Emplacement</strong> : un nouveau produit entre toujours en stock ; son dépôt
            est obligatoire à la création (Villebon est proposé par défaut). Il ne peut pas être
            créé directement dans une laverie : il y est affecté par une activité de préparation.
            Ensuite, la laverie et le dépôt sont en lecture seule et ne changent que par les
            activités de préparation, d'installation et d'enlèvement.
          </li>
          <li>
            <strong>Cycle de vie</strong> : l'étape actuelle du produit, en lecture seule (voir
            « Cycle de vie des produits »).
          </li>
          <li>
            <strong>Remplacer</strong> : ce bouton, visible lorsque le produit est installé, demande
            son remplacement. Le produit est ajouté à l'activité d'enlèvement de sa laverie. Un
            produit de remplacement peut être choisi parmi les produits en stock : il est alors
            ajouté à l'activité de préparation de la même laverie.
          </li>
          <li>
            <strong>Historique</strong> : chaque passage du produit dans une laverie ou un dépôt
            est affiché dans une carte, du plus récent au plus ancien. La carte indique la période
            (« Du … au … », ou « Depuis le … » avec le badge « Actuel » pour l'emplacement actuel).
            Pour une laverie, une frise chronologique liste en plus les étapes du cycle de vie avec
            leur date : affectation, préparation à reprendre, préparation approuvée, installation,
            validation de l'installation, demande d'enlèvement, enlèvement et annulation. Ces dates
            sont renseignées automatiquement par les activités.
          </li>
        </ul>

        <v-divider class="my-4"></v-divider>

        <p class="text-h6 text-left text-blue-darken-3">Cycle de vie des produits</p>
        <p class="text-body-1 text-left">
          Le cycle de vie d'un produit est entièrement géré par les activités de
          <strong>préparation</strong>, d'<strong>installation</strong> et
          d'<strong>enlèvement</strong>. Une même activité peut concerner plusieurs produits d'une
          même laverie. Un produit passe par les étapes suivantes :
        </p>
        <ul class="text-body-1 text-left ml-6">
          <li><strong>En stock</strong> : le produit est dans un dépôt (Villebon).</li>
          <li><strong>En préparation</strong> : le produit est affecté à une laverie et en cours de préparation.</li>
          <li><strong>En préparation à reprendre</strong> : la préparation a été refusée et doit être refaite.</li>
          <li><strong>Prêt à être installé</strong> : la préparation est approuvée et le produit attend son installation.</li>
          <li><strong>Installé</strong> : le produit est en exploitation dans la laverie.</li>
          <li><strong>En attente d'enlèvement</strong> : le produit doit être retiré de la laverie.</li>
        </ul>

        <p class="text-subtitle-1 text-left text-blue-darken-3 mt-4">Installation d'un produit</p>
        <ol class="text-body-1 text-left ml-6">
          <li>
            Un nouveau produit entre en stock au dépôt de Villebon. Sa date d'entrée est la date
            de son bon d'entrée.
          </li>
          <li>
            Une fois le contrat de la laverie signé, des produits en stock lui sont affectés, dans
            la limite des quantités prévues par le contrat : depuis le panneau « Produits » de la
            laverie, ou en créant une activité de préparation. Les produits passent « En
            préparation » dans l'activité de préparation de la laverie, créée automatiquement si
            besoin (voir « Nouvelle laverie : du contrat à l'installation des produits »).
          </li>
          <li>
            Chaque produit est contrôlé depuis la carte « Produits » de l'activité :
            <strong>Approuver</strong> ou <strong>À reprendre</strong>. Une préparation à reprendre
            peut être approuvée plus tard dans la même activité. Pour être approuvé, le produit
            doit avoir un numéro Aqua unique.
          </li>
          <li>
            Chaque produit approuvé passe « Prêt à être installé » et est ajouté automatiquement à
            l'activité d'installation ouverte de la laverie, qui est créée si besoin. Il y a une
            seule activité d'installation ouverte par laverie.
          </li>
          <li>
            Lorsque tous les produits sont approuvés, l'activité de préparation passe
            automatiquement « Approuvé ». L'activité peut aussi être approuvée directement : tous
            ses produits en préparation sont alors approuvés. Ce n'est pas possible si l'un d'eux
            est à reprendre.
          </li>
          <li>
            L'activité d'installation est ajoutée à une tournée et assignée à un technicien.
            Lorsque le technicien la passe à « Faite », tous ses produits sont installés : ils
            passent « Installé », en exploitation, et sortent du stock de Villebon. La date
            d'installation est la date d'affectation.
          </li>
        </ol>

        <p class="text-subtitle-1 text-left text-blue-darken-3 mt-4">Enlèvement et remplacement d'un produit</p>
        <ol class="text-body-1 text-left ml-6">
          <li>
            Une activité d'enlèvement est créée pour une laverie avec un ou plusieurs de ses
            produits installés, ou bien le bouton <strong>Remplacer</strong> de la fiche produit
            est utilisé. Les produits passent « En attente d'enlèvement ».
          </li>
          <li>
            En cas de remplacement, le nouveau produit suit tout le cycle d'installation décrit
            ci-dessus.
          </li>
          <li>
            L'activité d'enlèvement est ajoutée à une tournée et assignée à un technicien. Lorsque
            le technicien la passe à « Faite », ses produits reviennent en stock au dépôt de retour
            par défaut (Villebon), comme produits d'occasion. La date d'enlèvement est la date de
            retour au dépôt.
          </li>
        </ol>

        <p class="text-subtitle-1 text-left text-blue-darken-3 mt-4">Actions sur les produits d'une activité</p>
        <p class="text-body-1 text-left">
          La carte « Produits » du formulaire d'activité liste chaque produit avec son numéro Aqua
          et son étape du cycle de vie. Selon l'activité et l'étape du produit, elle propose
          jusqu'à quatre actions. Après chaque action, un message confirme l'opération et
          l'activité est rechargée pour afficher les nouvelles étapes.
        </p>
        <ul class="text-body-1 text-left ml-6">
          <li>
            <strong>Approuver</strong> : visible dans une activité de préparation, pour un produit
            « En préparation » ou « En préparation à reprendre ». La préparation du produit est
            validée. Résultat attendu :
            <ul class="ml-6">
              <li>le produit passe « Prêt à être installé » et la date « Préparation approuvée » est
                enregistrée dans son historique ;</li>
              <li>le produit est ajouté à l'activité d'installation de la laverie qui n'a pas encore
                commencé. Si aucune n'existe, une activité « Installation » est créée avec le
                statut « À faire » ;</li>
              <li>lorsque plus aucun produit de la préparation n'attend de contrôle, l'activité de
                préparation passe automatiquement « Approuvé ».</li>
            </ul>
            L'approbation est refusée si le produit n'a pas de numéro Aqua ou si ce numéro est déjà
            utilisé par un autre produit : il faut d'abord corriger le numéro Aqua depuis la fiche
            produit.
          </li>
          <li>
            <strong>À reprendre</strong> : visible dans les mêmes cas que « Approuver ». La
            préparation du produit est refusée et doit être refaite. Résultat attendu :
            <ul class="ml-6">
              <li>le produit passe « En préparation à reprendre » et la date « Préparation à
                reprendre » est enregistrée dans son historique ;</li>
              <li>le produit reste dans l'activité et reste affecté à la laverie. Une fois la
                préparation refaite, il peut être approuvé dans la même activité ;</li>
              <li>tant qu'un produit est à reprendre, l'activité de préparation ne peut pas être
                approuvée.</li>
            </ul>
          </li>
          <li>
            <strong>Reporter</strong> : visible dans une activité de préparation, d'installation ou
            d'enlèvement qui n'est pas encore « Faite » ou « Approuvé ». Elle sert pour un produit
            qui ne peut pas être traité lors de cette activité, par exemple s'il manque une pièce
            ou si le technicien n'a pas eu le temps. Résultat attendu :
            <ul class="ml-6">
              <li>le produit est retiré de l'activité. Il garde son étape du cycle de vie et reste
                affecté à la laverie ;</li>
              <li>il est ajouté à l'activité du même type et de la même laverie qui n'a pas encore
                commencé. Si aucune n'existe, une nouvelle activité est créée avec le statut « À
                faire » et devra être planifiée dans une tournée ;</li>
              <li>les autres produits de l'activité ne sont pas concernés. Lorsque l'activité sera
                validée, le produit reporté ne sera ni installé ni enlevé.</li>
            </ul>
          </li>
          <li>
            <strong>Retirer</strong> : visible dans une activité de préparation qui n'est pas encore
            « Faite » ou « Approuvé », pour un produit « En préparation » ou « En préparation à
            reprendre ». Elle sert pour un produit affecté par erreur, et demande une confirmation.
            Résultat attendu :
            <ul class="ml-6">
              <li>le produit est retiré de l'activité et revient « En stock » ; il n'est plus
                affecté à la laverie et sa place au contrat se libère. La date « Annulation » est
                enregistrée dans son historique ;</li>
              <li>si c'était le dernier produit de l'activité, l'activité de préparation est
                supprimée ;</li>
              <li>si tous les autres produits de l'activité sont approuvés, l'activité passe
                automatiquement « Approuvé ».</li>
            </ul>
          </li>
        </ul>
        <p class="text-body-1 text-left">
          Il n'y a pas d'action par produit pour l'installation et l'enlèvement : passer l'activité
          à « Faite » installe ou enlève tous les produits qu'elle contient encore.
        </p>

        <p class="text-subtitle-1 text-left text-blue-darken-3 mt-4">Supprimer une activité</p>
        <p class="text-body-1 text-left">
          Supprimer une activité annule son étape pour les produits qui ne l'ont pas encore
          franchie. Les produits d'une préparation ou d'une installation reviennent « En stock » et
          sont désaffectés de la laverie, et la date « Annulation » est enregistrée dans leur
          historique. Les produits d'un enlèvement redeviennent « Installé », et leur date
          « Demande d'enlèvement » est effacée.
        </p>

        <v-divider class="my-4"></v-divider>

        <p class="text-h6 text-left text-blue-darken-3">Pièces détachées</p>
        <p class="text-body-1 text-left">
          La liste des « Pièces détachées » affiche toutes les pièces dans un tableau consultable
          et sélectionnable. Des interrupteurs permettent de filtrer les pièces par fabricant
          (Speed Queen, LG, Maytag, Primus) et par type de machine (LL, SL, SLL, SSL, Condensateur,
          Armoire, Terminal, Balon, Bidon). Vous pouvez y ajouter une nouvelle pièce, en modifier
          une existante en cliquant sur sa ligne, supprimer une ou plusieurs pièces sélectionnées,
          rechercher des pièces par nom, référence, téléphone ou email, et exporter le tableau.
        </p>
        <p class="text-body-1 text-left">
          Le formulaire de pièce détachée permet de sélectionner un fabricant, puis d'associer à
          la pièce plusieurs types de machine et plusieurs modèles de produits (la liste des
          modèles dépend du fabricant choisi), en plus des informations habituelles (statut,
          désignation, référence, prix, stock, etc.).
        </p>

        <v-divider class="my-4"></v-divider>

        <p class="text-h6 text-left text-blue-darken-3">Tournées technicien</p>
        <p class="text-body-1 text-left">
          La liste des « Tournées technicien » affiche toutes les tournées dans un tableau
          consultable et sélectionnable. Des interrupteurs permettent de filtrer les tournées par
          statut (À faire, Assigné, En cours, Faite, Approuvé). Vous pouvez y ajouter une nouvelle
          tournée, en modifier une existante en cliquant sur sa ligne, supprimer une ou plusieurs
          tournées sélectionnées, rechercher des tournées par nom, signataire, téléphone ou email,
          et exporter le tableau.
        </p>
        <p class="text-body-1 text-left">
          Une tournée regroupe un ensemble d'activités. Le formulaire de tournée permet de saisir
          le code de la tournée, les dates de début et de fin planifiées, le statut, un ou
          plusieurs techniciens ainsi qu'un véhicule. Depuis cette page, il est également possible
          d'assigner des activités à la tournée.
        </p>

        <v-divider class="my-4"></v-divider>

        <p class="text-h6 text-left text-blue-darken-3">Activités</p>
        <p class="text-body-1 text-left">
          La liste des « Activités » affiche toutes les activités dans un tableau consultable et
          sélectionnable. Des interrupteurs permettent de filtrer les activités par statut (À
          faire, En cours, Assigné, Approuvé) et par type (Panne, Caisse, Facturation, Location,
          Enlèvement, Installation, Préparation). Vous pouvez y ajouter une nouvelle activité, en
          modifier une existante en cliquant sur sa ligne, supprimer une ou plusieurs activités
          sélectionnées, rechercher des activités par type, et exporter le tableau. Les activités
          sélectionnées peuvent également être ajoutées à une tournée existante.
        </p>
        <p class="text-body-1 text-left">
          Le formulaire d'activité permet de renseigner un sujet, le type d'activité, la tournée
          rattachée, la laverie et éventuellement le produit concernés, le statut, la priorité,
          une observation, ainsi que des sous-tâches.
        </p>
        <p class="text-body-1 text-left">
          Pour les activités de préparation, d'installation et d'enlèvement :
        </p>
        <ul class="text-body-1 text-left ml-6">
          <li>
            Les activités d'installation sont créées automatiquement et ne peuvent pas être créées
            à la main.
          </li>
          <li>
            À la création d'une préparation ou d'un enlèvement, au moins un produit doit être
            choisi. Pour une préparation, ce sont des produits en stock ou dont la préparation est à
            reprendre, dans la limite du contrat signé de la laverie (voir « Produits d'une
            laverie »). Pour un enlèvement, ce sont des produits installés dans la laverie choisie.
          </li>
          <li>Le type d'une activité existante ne peut plus être modifié.</li>
          <li>
            La carte « Produits » liste les produits de l'activité avec leur étape du cycle de vie.
            Elle propose les boutons Approuver, À reprendre, Reporter et Retirer (voir « Actions sur
            les produits d'une activité »).
          </li>
        </ul>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts"></script>
